import { api } from "@/api"
import type { MaybeRef } from "@vueuse/core"
import { useQuery } from "@tanstack/vue-query"
import type { GlobalReportQueryFilters } from "@/composables/useReportQuery"

export type OverviewReportResponse = {
  totalItemGross: number

  totalServiceCharge: number

  totalGrossReceived: number
  totalGratuityReceived: number

  totalGrossRefunded: number
  totalGratuityRefunded: number

  warnIncorrectCurrencyTransaction: boolean
}

export type OverviewReportQuery = {
  deviceId?: number
  cashierId?: string
  start?: string
  end?: string
}

export type OverviewReportFilters = Omit<
  OverviewReportQuery,
  keyof GlobalReportQueryFilters
>

export const retrieveOverviewReport = async (
  query: OverviewReportQuery
): Promise<OverviewReportResponse> => {
  const { body } = await api.get<OverviewReportResponse>(
    "/reports/overview/",
    {
      query: query,
    }
  )
  return body
}

export const useOverviewReport = (
  query: MaybeRef<OverviewReportQuery>
) =>
  useQuery(
    [BASE_OVERVIEW_REPORT_QUERY_KEY, query] as const,
    ({ queryKey: [_name, query_] }) =>
      retrieveOverviewReport(unref(query_))
  )
